import { InjectionToken } from '@angular/core';

/**
 * Configuración para personalizar el comportamiento y apariencia del modal
 */
export interface CYModalConfig {
  /** Ancho del modal (ej: '500px', '50%', '80vw') */
  width?: string;

  /** Altura del modal (ej: '400px', '60vh') */
  height?: string;

  /** Ancho máximo del modal (ej: '90vw', '800px') */
  maxWidth?: string;

  /** Altura máxima del modal (ej: '90vh', '600px') */
  maxHeight?: string;

  /** Si es true, previene el cierre del modal con ESC o click en backdrop */
  disableClose?: boolean;

  /** Clases CSS adicionales para el contenedor del modal */
  panelClass?: string | string[];

  /** Clases CSS adicionales para el backdrop del modal */
  backdropClass?: string | string[];

  /** Datos a pasar al componente hijo (se asignan como propiedades) */
  data?: any;

  /**
   * Si es true, muestra el backdrop del modal
   */
  hasBackdrop?: boolean;
}

/**
 * Referencia al modal creado que permite controlarlo desde el exterior
 *
 * @template T - Tipo del componente mostrado en el modal
 */
export interface CYModalRef<T = any> {
  /** Instancia del componente mostrado en el modal */
  componentInstance: T | undefined;

  /**
   * Cierra el modal inmediatamente sin animación
   * @param result - Resultado opcional para pasar a afterClosed
   */
  close: (result?: any) => void;

  /**
   * Cierra el modal con animación suave
   */
  closeWithAnimation: () => void;

  /**
   * Promesa que se resuelve cuando el modal se cierra
   * @returns Promise que resuelve con el resultado del cierre
   */
  afterClosed: () => Promise<any>;
}

/**
 * Nueva interface para el contexto del modal actual
 * Similar a como Ionic inyecta la referencia del modal
 */
export interface CYCurrentModalContext {
  id: string;
  close: (result?: any) => void;
  dismiss: (result?: any) => void;
  closeWithAnimation: () => void;
}

/**
 * Token de inyección para el modal actual
 * Permite que cualquier componente hijo acceda a su modal padre
 */
export const CY_CURRENT_MODAL = new InjectionToken<CYCurrentModalContext>('CY_CURRENT_MODAL');
